import { BookingPaymentInfo } from '@jucy-ui/common';
import { format } from 'date-fns';
import { formatCurrency } from '#/components/CurrencyFormatter/CurrencyFormatter';

export const getPaymentUniqueKey = (paymentInfo: BookingPaymentInfo) => {
    const keyParts = ['paymentz', paymentInfo.merchantFeeName, format(paymentInfo.date, 'dd-MM-yyyy'), paymentInfo.total ? formatCurrency(paymentInfo.total) : undefined].filter(Boolean);
    return keyParts.join('-');
};
